import React from 'react'
import Header from '../components/Header'
import './Benefits.css'
import { useNavigate } from 'react-router-dom'

const BENEFITS = [
  {
    icon: '📋',
    title: 'Effortless Gym Management',
    text: 'Track all monthly bookings, payments, and visited customers in one place.',
    color: '#60a5fa',
  },
  {
    icon: '⏰',
    title: 'Exciting Rewards',
    text: 'Accumulate 100 booking hours and unlock exclusive prizes and milestone rewards.',
    color: '#f59e0b',
  },
  {
    icon: '📈',
    title: 'Growth & Analytics',
    text: 'Get insights into your gym\'s performance and customer engagement to maximize revenue.',
    color: '#34d399',
  },
  {
    icon: '🏆',
    title: 'Achieve More Milestones',
    text: 'Unlock new levels of success with our gym management tools and reward system.',
    color: '#a78bfa',
  },
  {
    icon: '💳',
    title: 'Seamless Payments',
    text: 'Manage subscriptions and payouts with automatic tracking and bank integration.',
    color: '#fb923c',
  },
  {
    icon: '📱',
    title: 'QR Check-ins',
    text: 'Let members check in instantly with unique QR codes — no paperwork required.',
    color: '#f472b6',
  },
]

const GymBenefits = () => {
  const navigate = useNavigate()

  return (
    <div className="benefits-page">
      <Header />
      <div className="bnf-content">
        <div className="bnf-hero">
          <h1 className="bnf-hero-title">Why Choose Yupluck?</h1>
          <p className="bnf-hero-sub">
            The all-in-one gym management platform — streamline operations, increase revenue, and delight your members.
          </p>
        </div>

        <div className="bnf-grid">
          {BENEFITS.map((b, i) => (
            <div className="bnf-card" key={i}>
              <div className="bnf-card-icon" style={{ background: `${b.color}18`, color: b.color }}>
                {b.icon}
              </div>
              <h3 className="bnf-card-title">{b.title}</h3>
              <p className="bnf-card-text">{b.text}</p>
            </div>
          ))}
        </div>

        <div className="bnf-cta">
          <h2 className="bnf-cta-title">Ready to grow your gym?</h2>
          <p className="bnf-cta-sub">Join thousands of gym owners already using Yupluck. It's completely free.</p>
          <button className="bnf-cta-btn" onClick={() => navigate('/register')}>
            Get Started Free →
          </button>
        </div>
      </div>
    </div>
  )
}

export default GymBenefits
